import { createContext, useContext, type ReactNode } from 'react';
import { useSseNotifications, type UseSseNotificationsReturn } from '~/hooks/use-sse-notifications';
import type { AccountType } from '~/lib/permissions';

const SseNotificationsContext = createContext<UseSseNotificationsReturn | null>(null);

export function SseNotificationsProvider({
  activeRole,
  children,
}: {
  activeRole: AccountType | undefined;
  children: ReactNode;
}) {
  const value = useSseNotifications({
    autoConnect: activeRole === 'LEARNER',
  });

  return (
    <SseNotificationsContext.Provider value={value}>{children}</SseNotificationsContext.Provider>
  );
}

export function useSseNotificationsContext(): UseSseNotificationsReturn | null {
  return useContext(SseNotificationsContext);
}
